import CloseButton from "../../../../components/CloseButton/CloseButton"
import { usePostPurchase } from "../../../../context/postPurchaseContext"
import useStrings from "../../../../localization/useStrings"
import native from "../../../../native/native"
import svg from "../../../../utils/svg"
import styles from "./Header.module.scss"

const Header = () => {
  const strings = useStrings()
  const promoStrings = strings.premiumToUltimateBlackFriday
  const premiumToUltimateStrings = strings.premiumToUltimate
  const state = usePostPurchase().state
  const savingPercentage = state.promoPricing?.savingPercent ?? "0"

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <label className={styles.title}>
          {premiumToUltimateStrings.titleLine1}
          <br />
          {premiumToUltimateStrings.titleLine2}
        </label>

        <CloseButton
          onClick={() => {
            native.postNativeEvent("close")
          }}
        />
      </div>
      <div className={styles.subtitleContainer}>
        <label className={styles.savingValue}>{savingPercentage}</label>
        <div className={styles.offContainer}>
          <label className={styles.savingPercent}>%</label>
          <label className={styles.savingOff}>{strings.off}</label>
        </div>
      </div>
      <div className={styles.goUltimateContainer}>
        <label>{promoStrings.subTitle}</label>
        <svg.UltimateIcon width={20} height={16} fill="white" />
      </div>
    </div>
  )
}

export default Header
